function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.248795 6.704V1.928C0.248795 1.616 0.356795 1.352 0.572795 1.136C0.796795 0.912 1.06479 0.8 1.37679 0.8H6.15279C6.46479 0.8 6.73279 0.908 6.95679 1.124L11.9248 6.092C12.1408 6.316 12.2488 6.584 12.2488 6.896C12.2488 7.2 12.1408 7.464 11.9248 7.688L7.13679 12.476C6.91279 12.692 6.64479 12.8 6.33279 12.8C6.02879 12.8 5.76479 12.692 5.54079 12.476L0.584795 7.508C0.480795 7.404 0.396795 7.284 0.332795 7.148C0.276795 7.004 0.248795 6.856 0.248795 6.704ZM2.87679 2.3C2.56479 2.3 2.29679 2.412 2.07279 2.636C1.85679 2.852 1.74879 3.116 1.74879 3.428C1.74879 3.74 1.85679 4.004 2.07279 4.22C2.29679 4.436 2.56479 4.544 2.87679 4.544C3.18879 4.544 3.45279 4.436 3.66879 4.22C3.89279 3.996 4.00479 3.732 4.00479 3.428C4.00479 3.124 3.89279 2.86 3.66879 2.636C3.45279 2.412 3.18879 2.3 2.87679 2.3Z",
  fill: "currentColor"
});

var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.f293c5a2.svg";
export { ForwardRef as ReactComponent };